import { resolveCareDemo } from './careDemoData';

const CARE_API_BASE = process.env.REACT_APP_CARE_API_URL || '/mobile-api';
const TOKEN_KEY = 'chutex_care_admin_token';
const DEMO_KEY = 'care_demo_mode';

export function getCareToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

export function setCareToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Mode démo OFF par défaut en prod.
 * Activation : REACT_APP_CARE_DEMO=true, ou bouton « Démo » (localStorage).
 */
export function isCareDemoMode() {
  if (process.env.REACT_APP_CARE_DEMO === 'true') return true;
  if (process.env.REACT_APP_CARE_DEMO === 'false') return false;
  try {
    return localStorage.getItem(DEMO_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setCareDemoMode(on) {
  try {
    localStorage.setItem(DEMO_KEY, on ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

export function unwrapItems(res) {
  if (Array.isArray(res)) return res;
  return res?.items || [];
}

async function _fetchLive(path, options, token) {
  const authToken = token || getCareToken();
  const url = `${CARE_API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (authToken) headers.Authorization = `Bearer ${authToken}`;

  const res = await fetch(url, {
    ...options,
    headers,
    body: options.body,
  });

  const text = await res.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }

  if (!res.ok) {
    const msg = data?.detail || data?.message || (typeof data === 'string' ? data : `Erreur ${res.status}`);
    const err = new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function careFetch(path, options = {}, token) {
  const clean = path.split('?')[0];
  const isAuth = clean.startsWith('/auth/');
  const method = (options.method || 'GET').toUpperCase();

  if (!isAuth && isCareDemoMode()) {
    if (method !== 'GET') {
      const err = new Error('Mode démo · les actions opérateur sont désactivées. Passez en données réelles.');
      err.status = 403;
      err.demoBlocked = true;
      throw err;
    }
    await new Promise((r) => setTimeout(r, 80));
    return resolveCareDemo(path, options);
  }

  return _fetchLive(path, options, token);
}

export async function careLoginWithPassword(password) {
  return careFetch('/auth/care-admin-login', {
    method: 'POST',
    body: JSON.stringify({ password }),
  });
}

export async function careFetchMe(token) {
  return careFetch('/auth/me', {}, token);
}

export function userHasTeleassistanceRole(user) {
  const roles = user?.roles || [];
  return roles.some((r) => r.code === 'teleassistance');
}
